module.exports = [{"id":"4abfd8fd-f22a-4e1a-ad03-0b31b2942357","dptype":0,"store_id":"018b93de-5fda-4f4e-9743-d707da6d0379","dpindex":19022,"completed":0,"cancelled":0,"active":20,"duration":30,"favorites":0,"first":0,"createdAt":"2022-01-25T12:54:26.944Z","updatedAt":"2022-01-25T12:54:26.944Z"},{"id":"4abfd8fd-f22a-4e1a-ad03-0b31b2942300","dptype":0,"store_id":"018b93de-5fda-4f4e-9743-d707da6d0379","dpindex":19018,"completed":1,"cancelled":3,"active":19,"duration":30,"favorites":0,"first":0,"createdAt":"2022-01-25T12:54:26.944Z","updatedAt":"2022-01-25T12:54:26.944Z"}]


//////////////////
// WEBPACK FOOTER
// ./data/storedatademo.json
// module id = rnr6
// module chunks = 1